<template>
  <div class="center">
    <img src="~@/assets/img/SB-Images/empty.svg">
    <h1>You haven't created any WhatsApp<br>Message Template. </h1>
    <p>Go to AI Number Dashboard to create new WhatsApp Message Templates.</p>
    <b-button
      class="blue box-shadow"
      @click="redirectToNotificationTemplates">Create Message Template</b-button>
  </div>
</template>

<script>
export default {
  name: 'NoTemplate',
  methods: {
    redirectToNotificationTemplates() {
      this.$router.push({ name: 'SentNotifications' });
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  margin-top: 36px;
  margin-bottom: 24px;
}

h1 {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  color: $blackPrimary;
  margin-bottom: 16px;
}

p {
  font-size: 14px;
  line-height: 1.21;
  color: $blackLight;
  margin-bottom: 30px;
}

.btn {
  margin-top: 0 !important;
  margin-bottom: 36px !important;
  padding: 6px 16px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 1.2 !important;
  color: $white !important;
}
</style>
